/**
 * Safely converts a Firestore field value (Timestamp, Date, ISO string, number,
 * or null/undefined) to a JS Date.  Returns new Date(0) for values that cannot
 * be converted so callers never crash on bad / missing timestamp data.
 */
export function toDateSafe(value: unknown): Date {
  if (
    value != null &&
    typeof value === 'object' &&
    'toDate' in value &&
    typeof (value as { toDate: unknown }).toDate === 'function'
  ) {
    return (value as { toDate: () => Date }).toDate();
  }
  if (value instanceof Date) return value;
  if (typeof value === 'string' || typeof value === 'number') {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? new Date(0) : d;
  }
  return new Date(0);
}
